import React, { useCallback } from 'react';
import { LATEST_PACKAGE_FOLDER, latestPackage, type PackageDetails } from '../../services/Clients/S3Client';

interface IProps {
  readonly packages?: PackageDetails[]; // aka versions
  readonly selected: PackageDetails | null;
  readonly onChange: (packageFolder: string) => void;
}

const PackageOptions: React.FC<IProps> = ({ packages, selected, onChange }) => {
  const latestPkg = latestPackage();
  const renderOption = useCallback((p: PackageDetails, index: number) => {
    const selectedFolder = selected ? selected.folder : null;
    const isSelected = p.folder === selectedFolder;
    // We are assuming latestPackage() is the first option when no version is explicitly selected for a branch
    const isMostRecentChoice = selectedFolder === null && index === 0 && p.folder === LATEST_PACKAGE_FOLDER;
    const isActive = isSelected || isMostRecentChoice;
    const check = isActive ? " ✓" : null;

    return (
      <button
        type="button"
        className={`scolab-switcher-s3dialogselector-choice ${isActive ? 'active' : ''}`}
        key={p.folder}
        value={p.folder}
        onClick={() => onChange(p.folder)}
      >
        <strong>{p.label}{check}</strong>
        <time>{p.dateLabel}</time>
      </button>
    );
  }, [selected, onChange]);

  if (!selected || !packages) {
    return null;
  }

  // This ensures that the latest package is always the first option
  const versionsWithLatest = [latestPkg].concat(packages.filter(v => v.folder !== LATEST_PACKAGE_FOLDER));
  return (
    <div className="scolab-switcher-s3dialogselector-popup scolab-switcher-s3dialogselector-popup-versions">
      {versionsWithLatest.map(renderOption)}
    </div>
  );
};

export default PackageOptions;
